import React, { useEffect, useState } from "react";
import { Typography, Box, Button } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../../Shared/Utill/AxiosConfig";
import {constants } from "../../../../../Shared/Url/Constants";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";

const DeleteRuleDialog = (props) => {
    const dialog = useToggle();
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookie.get('X_TKN');

    useEffect(() => {
        dialog.show();
    }, []);

    const deleteEventAction = () => {
        // call delet event  api
        console.log("request payload",props.arAId + props.effectiveDate)
        callDeleteService(props.arAId);
       
    }

    const callDeleteService = (araId) =>{
        if (props.ruleId === "999"){
            props.onDeleteCallback("error","Cannot delete Rule 999!")
        }
       
       axiosInstance.delete(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVL_RULE_DELETE}/${araId}`, {
        headers: {
          'content-type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
        .then((response) => {
         console.log("response is",response.data);
         if(response.status === 200){
          // success close popup
             props.onDeleteCallback("success",`Rule - ${props.ruleId} deleted successfully.`);   
         }else{
            props.onDeleteCallback("error","Something went wrong"); 
         }
        })
        .catch((error) => {
           //catch
         props.onDeleteCallback("error",error.response.data.message); 
        })
    }
  
    
    const closeDialog = () => {
        dialog.hide();
        props.onCloseDialog(); 
    }
    return (
        <Box>
            <Dialog
                open={dialog.open}
                title="Delete Rule"
                onClose={closeDialog}
                actions={
                    <>
                        <Button color="secondary" onClick={() => closeDialog()}>No</Button>
                        <Button onClick={() => deleteEventAction()}>Yes</Button>
                    </>
                }
            >
                <Typography>{`Are you sure you want to delete Rule - ${props.ruleId} for ${props.effectiveDate} .`}</Typography>
            </Dialog>
        </Box>
    );
}

export default DeleteRuleDialog;

